/**
 * ATTENTION: This file is auto generated by using "prepareTemplates".
 * Do not change the content!
 *
 */

/**
 * Library Index aria-live to autogenerate all the components and extensions
 * Used by "prepareAriaLives"
 */

import AriaLive from './aria-live/AriaLive'
export * from './aria-live/AriaLive'
export default AriaLive
